import { styled } from "styled-components";

export const InfoMonitorConnection = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;  
  font-size: 14px;
  padding:0;
  margin-top: 180px;
`;

export const LoadImage = styled.img`
  width: 25px;    
`;